// extracted by mini-css-extract-plugin
export var measureBox = "_82-0";